module.exports = __webpack_public_path__ + "media/3_1.8ae7aa7d.wav";